import React from 'react';
import { Stack, Pagination } from '@mui/material';
import PropTypes from 'prop-types';

export default function CandidatePagination({
  currentPage,
  handlePageChange,
  totalPages,
}) {
  return (
    <Stack direction="row" alignItems="center" spacing="10px">
      <Pagination
        count={totalPages}
        variant="outlined"
        shape="rounded"
        size="medium"
        page={currentPage}
        boundaryCount={3}
        onChange={handlePageChange}
      />
    </Stack>
  );
}

CandidatePagination.propTypes = {
  currentPage: PropTypes.number,
  handlePageChange: PropTypes.func,
  totalPages: PropTypes.number,
};
